import React, { useEffect } from 'react';

import GamesSummary from './GamesSummary';
import { useBreadcrumbs, usePath } from '../../hooks';
import { useTeam, useSeason } from '../shared/hooks';
import { usePaginatedGamesByMonth } from './usePaginatedGamesByMonth';
import { seasonName, teamName } from '../../lib/format';

function createBreadcrumbs(team, season, pathTo) {
  if (!team) return;

  return [
    { title: 'Teams', url: pathTo('teams') },
    { title: `[${seasonName(season)}] ${teamName(team)}`, url: pathTo('team') },
    { title: 'Games' },
  ];
}

const GamesSummaryPage = ({ leagueId, seasonId, teamId }) => {
  const team = useTeam(teamId);
  const season = useSeason(seasonId);
  const pathTo = usePath(leagueId, seasonId, teamId);
  useBreadcrumbs(createBreadcrumbs, [team, season, pathTo]);

  const {
    gamesByMonth,
    currentPage,
    total,
    pageSize,
    setCurrentPage,
  } = usePaginatedGamesByMonth(leagueId, seasonId, teamId);

  useEffect(() => {
    // FIXME: page should be on url route and react-router should handle scroll
    window.scrollTo(0, 0);
  }, [currentPage]);

  return (
    <GamesSummary
      team={team}
      gamesByMonth={gamesByMonth}
      currentPage={currentPage}
      pageSize={pageSize}
      itemsCount={total}
      onPageChange={setCurrentPage}
      pathTo={pathTo}
      season={season}
    />
  );
};

export default GamesSummaryPage;
